import { getAuth } from 'firebase/auth';

// Campos onde uma action costuma informar explicitamente o profissional responsável
// (o médico pelo qual a secretária está agindo). Rastreamos as actions de REQUEST
// justamente porque é nelas que esse id viaja (o _SUCCESS não o carrega).
const PAYLOAD_PROFESSIONAL_FIELDS = ['professional', 'professionalId', 'healthProfessionalId', 'doctorId'];

// Procura o id do profissional no payload — direto ou aninhado nos objetos comuns
// (quotation.professionalId, selectedData.professional do lote, appointment.professional).
function professionalFromPayload(action) {
  const payload = action && action.payload;
  if (!payload || typeof payload !== 'object') return null;
  const scan = (obj) => {
    if (!obj || typeof obj !== 'object') return null;
    for (let i = 0; i < PAYLOAD_PROFESSIONAL_FIELDS.length; i += 1) {
      const v = obj[PAYLOAD_PROFESSIONAL_FIELDS[i]];
      if (typeof v === 'string' && v) return v;
    }
    return null;
  };
  return scan(payload)
    || scan(payload.quotation)
    || scan(payload.selectedData)
    || scan(payload.appointment)
    || null;
}

// Resolve a quem atribuir o uso de uma ação:
//  - actorUid: quem executou (pode ser uma secretária / customUser)
//  - accountUid: a conta/clínica (mainUser) — ou o próprio ator se for conta principal
//  - professionalUid: o PROFISSIONAL RESPONSÁVEL pela ação
//  - attributedToAccount: true quando não foi possível resolver um profissional específico
//
// Ordem de resolução do profissional (mais preciso → fallback):
//  1) extrator por-feature (entry.getProfessionalUid), quando definido;
//  2) id do profissional informado no payload da action (secretária agindo pelo médico);
//  3) sub-profissional de saúde logado (state.Profile.customHealthProfessionalProfile);
//  4) profissional de saúde logado direto (claim healthProfessional) → o próprio ator;
//  5) fallback → a conta (dono, mainUser), marcando attributedToAccount.
export default function resolveAttribution(state, action, entry) {
  const actorUid = getAuth().currentUser ? getAuth().currentUser.uid : null;
  const auth = (state && state.Auth) || {};
  const accountUid = auth.mainUser || actorUid;

  let professionalUid = null;
  let attributedToAccount = false;

  if (entry && typeof entry.getProfessionalUid === 'function') {
    professionalUid = entry.getProfessionalUid(action, state) || null;
  }
  if (!professionalUid) {
    professionalUid = professionalFromPayload(action);
  }
  if (!professionalUid) {
    const chp = state && state.Profile && state.Profile.customHealthProfessionalProfile;
    if (chp && chp.id) professionalUid = chp.id;
  }
  if (!professionalUid && auth.healthProfessional) {
    professionalUid = actorUid;
  }
  if (!professionalUid) {
    // Sem dono claro → atribui à CONTA ATUAL (mainUser). Se nem a conta houver
    // (ex.: claim ainda não carregada), cai no próprio ator, pra nunca perder
    // o registro de quem fez a ação.
    professionalUid = accountUid || actorUid;
    attributedToAccount = true;
  }

  return {
    actorUid,
    accountUid,
    professionalUid,
    attributedToAccount,
  };
}
